export default __webpack_public_path__ + "static/media/Game_Paused_img.86ded217.png";